import type { JobStep } from "@/lib/api/types";
import { formatEuro } from "@/lib/format";

// Der Status steht immer als Text, Symbol und Farbe kommen nur dazu (CLAUDE.md „Frontend“)
const STATES: Record<JobStep["status"], { symbol: string; dot: string; label: string }> = {
  pending: { symbol: "", dot: "border border-field bg-white", label: "wartet" },
  running: { symbol: "", dot: "animate-pulse bg-accent", label: "läuft …" },
  done: { symbol: "✓", dot: "bg-success text-white", label: "fertig" },
  error: { symbol: "×", dot: "bg-danger text-white", label: "Fehler" },
  skipped: { symbol: "–", dot: "bg-neutral-bg text-muted", label: "übersprungen" },
};

export function StepRow({ step }: { step: JobStep }) {
  const state = STATES[step.status];
  return (
    <li className="flex flex-wrap items-center gap-3 border-t border-neutral-bg py-2.5">
      <span
        aria-hidden="true"
        className={`flex size-4 shrink-0 items-center justify-center rounded-full text-[10px] leading-none ${state.dot}`}
      >
        {state.symbol}
      </span>
      <span className="flex min-w-[240px] flex-1 flex-col gap-0.5">
        <span className="text-sm font-medium">{step.title}</span>
        <span className="font-mono text-xs text-muted">{step.endpoint}</span>
      </span>
      <span className="text-[13px] text-[#3a424a]">
        {step.status === "done" && step.result ? step.result : state.label}
        {step.status === "done" && step.cost_eur ? ` · ${formatEuro(step.cost_eur)}` : ""}
      </span>
    </li>
  );
}
